var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({ref:"editable",class:{
    'text-success': +_vm.value >= 0 && _vm.color,
    'text-danger': +_vm.value < 0 && _vm.color,
    'text-strong': _vm.bold,
  },attrs:{"contenteditable":"","onclick":"document.execCommand('selectAll', false, null)"}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }